exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".operation-failure-message{text-align:center;color:#fff}.operation-failure-message .error-message{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/OperationFailureMessage/index.scss
// module id = 1016
// module chunks = 0